<template>
  <div class="view-orders-done">
    <app-svg-icon name="success" class="view-orders-done__svg" />
    <h2 class="view-orders-done__title">
      Заказ № {{ numberNewOrder }} оформлен
    </h2>
    <div class="view-orders-done__btn-group">
      <app-button-control
        route="/offers"
        size="large"
        type="secondary"
        class="view-orders-done__btn"
      >
        Перейти в каталог
      </app-button-control>
      <app-button-control
        :route="`/orders/item/${numberNewOrder}`"
        size="large"
        class="view-orders-done__btn"
      >
        Перейти к заказу
      </app-button-control>
    </div>
    <a :href="url" target="_blank" class="view-orders-done__link" v-if="url"
      >Продолжить оформление рассрочки на сайте Альфа Банка</a
    >
    <div v-if="showErrorText" class="view-orders-done__error">
      Заявку на кредит создать не удалось, повторите позднее на странице заказа
    </div>
  </div>
</template>

<script>
import { AlfaApi } from '@/api/AlfaApi';
import { ordersMapper } from '@/store/orders';

export default {
  name: 'ViewOrdersDone',
  components: {
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
  },
  data: () => ({
    url: '',
    showErrorText: false,
  }),
  computed: {
    ...ordersMapper.mapState(['numberNewOrder']),
  },
  async created() {
    if (!this.numberNewOrder) {
      this.$router.push('/');
    }
    if (this.$route.query.alfa) {
      await this.getAlfaCreditRequests(this.numberNewOrder);
    }
  },
  beforeDestroy() {
    this.SET_NUMBER_NEW_ORDER();
  },
  methods: {
    ...ordersMapper.mapActions(['postAlfaCreditRequests']),
    ...ordersMapper.mapMutations(['SET_NUMBER_NEW_ORDER']),
    async getAlfaCreditRequests(orderNumber) {
      try {
        const alfaApi = new AlfaApi();
        const { url } = await alfaApi.getAlfaCreditRequests(orderNumber);
        this.url = url;
      } catch (error) {
        this.showErrorText = true;
        // -
      }
    },
  },
};
</script>

<style lang="scss">
.view-orders-done {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__error {
    color: #ef3124;
    text-align: center;
  }

  &__link {
    font-size: 16px;
    color: #ef3124;
    text-align: center;
  }

  &__svg {
    width: 100%;
    max-width: 350px;
    height: 350px;
  }

  &__btn-group {
    display: flex;

    @include media-xs() {
      display: flex;
      flex-direction: column;
    }
  }

  &__btn {
    margin-right: 15px;
    margin-bottom: 15px;

    @include media-xs() {
      margin-right: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
